// eslint-disable-next-line import/no-cycle
import {

    // Staff Management
    SETTING_LOAD_DEPARTMENT,
    SETTING_LOAD_DEPARTMENT_SUCCESS,
    SETTING_CREATE_DEPARTMENT,
    SETTING_UPDATE_DEPARTMENT,
    SETTING_DELETE_DEPARTMENT,

    SETTING_LOAD_POSITION,
    SETTING_LOAD_POSITION_SUCCESS,
    SETTING_CREATE_POSITION,
    SETTING_UPDATE_POSITION,
    SETTING_DELETE_POSITION,

    SETTING_LOAD_STAFF,
    SETTING_LOAD_STAFF_SUCCESS,
    SETTING_CREATE_STAFF,
    SETTING_UPDATE_STAFF,
    SETTING_DELETE_STAFF,
    // END Staff Management

} from '../../actions';


// export const settingErrorMessage = (data) => ({
//     type: SETTING_ERROR_MESSAGE,
//     payload: data
// })

// export const closeSettingErrorMessage = () => ({
//     type: CLOSE_SETTING_ERROR_MESSAGE
// });

// // -------------------- Staff Management --------------------- //
export const getDepartment = (data, token) => ({
    type: SETTING_LOAD_DEPARTMENT,
    payload: data,
    token
});
export const getDepartmentSuccess = (data, list) => ({
    type: SETTING_LOAD_DEPARTMENT_SUCCESS,
    payload: data,
    payloadlist: list
});
export const addDepartment = (data, token) => ({
    type: SETTING_CREATE_DEPARTMENT,
    payload: data,
    token
});
export const updateDepartment = (data, token) => ({
    type: SETTING_UPDATE_DEPARTMENT,
    payload: data,
    token
});
export const deleteDepartment = (data, token) => ({
    type: SETTING_DELETE_DEPARTMENT,
    payload: data,
    token
});
// 
export const getPosition = (data, token) => ({
    type: SETTING_LOAD_POSITION,
    payload: data,
    token
});
export const getPositionSuccess = (data, list) => ({
    type: SETTING_LOAD_POSITION_SUCCESS,
    payload: data,
    payloadlist: list
});
export const addPosition = (data, token) => ({
    type: SETTING_CREATE_POSITION,
    payload: data,
    token
});
export const updatePosition = (data, token) => ({
    type: SETTING_UPDATE_POSITION,
    payload: data,
    token
});
export const deletePosition = (data, token) => ({
    type: SETTING_DELETE_POSITION,
    payload: data,
    token
});
//
export const getStaff = (data, token) => ({
    type: SETTING_LOAD_STAFF,
    payload: data,
    token
});
export const getStaffSuccess = (data, list) => ({
    type: SETTING_LOAD_STAFF_SUCCESS,
    payload: data,
    payloadlist: list
});
export const createStaff = (data, token) => ({
    type: SETTING_CREATE_STAFF,
    payload: data,
    token
});
export const updateStaff = (data, token) => ({
    type: SETTING_UPDATE_STAFF,
    payload: data,
    token
});
export const deleteStaff = (data, token) => ({
    type: SETTING_DELETE_STAFF,
    payload: data,
    token
});
// // -------------------- END Staff Management --------------------- //